import React, { useEffect, useState } from 'react';
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
  Modal,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  ModalHeader,
} from 'reactstrap';
import * as Icon from 'react-feather';
import { connect } from 'react-redux';
import Tracker from '@openreplay/tracker';
import {
  logoutMS,
  logoutWithJWT,
} from '../../../redux/actions/auth/loginActions';
import {
  setProfile,
  setCustomerProfile,
} from '../../../redux/actions/profile/profile';
import { getCustomerProfile, getProfile } from '../../../actions/profile';
import { toggleCustomerView } from '../../../redux/actions/options';
import { history } from '../../../history';
import { setJWT } from '../../../helpers/JWTShare';
import { updateGAUser } from '../../../helpers/GoogleAnalytics';
import jwt from 'jsonwebtoken';
import { setPreviewToken, getPreviewToken } from '../../../helpers/Token';
import { useLocation } from 'react-router-dom';
import { getCustomers, getPersons } from '../../../actions/customer';
import './navbarUser.css';


const tracker = new Tracker({
  projectKey: "474g6dbLZlfQAHFu6tUX",
  ingestPoint: "https://openreplay.boltinsight.com/ingest",
});
tracker.start();

const UserDropdown = (props) => {
  const [projects, setProjects] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedPersons, setSelectedPersons] = useState([]);
  const [selectProfile, setSelectProfile] = useState('');
  const toggle = () => setModal(!modal);
  const location = useLocation();
  useEffect(() => {
    handleProjects();
  }, []);
  const handleProjects = async () => {
    try {
      let previewToken = await getPreviewToken();
      previewToken
        ? props.toggleCustomerView(true)
        : props.toggleCustomerView(false);
      let result = await getCustomers();

      setProjects(result.data.customers);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSelectedCustomer = async (e) => {
    setSelectedCustomer(e.target.value);
    let result = await getPersons(e.target.value);
    setSelectedPersons(result?.data?.persons);
  };
  const handleSelectProfile = (e) => {
    setSelectProfile(e.target.value);
  };
  const jwtConfig = {
    secret: 'AB-9/Y$[<=>O!n@Y,kQ@hW2)A:Z(NbjdS:Lr',
    expireTime: 8000,
  };
  const setProfile = async () => {
    props.setProfile({
      name: `${selectedPersons[selectProfile].fname} ${selectedPersons[selectProfile].lname}`,
      email: selectedPersons[selectProfile].email,
      role: 'User',
      personId: selectedPersons[selectProfile].id,
      isAdmin: false,
    });
    const accessToken =
      'JWT ' +
      jwt.sign(
        { userId: selectedPersons[selectProfile].personId },
        jwtConfig.secret,
        {
          expiresIn: jwtConfig.expireTime,
        }
      );
    setPreviewToken(accessToken);
    setModal(!modal);
    props.toggleCustomerView(true);
    location.pathname === '/projects'
      ? history.push('/reports')
      : history.push('/projects');
  };
  return (
    <DropdownMenu right>
      {(props.profile.role === 'Super' || props.profile.role === 'Manager') &&
      !props.options.isCustomerView ? (
        <DropdownItem tag="a" href="#" onClick={() => toggle()}>
          <div>
            <div className="customer-view">
              <Icon.User size={14} className="mr-50" />
              <span>Customer View</span>
            </div>
            <Modal isOpen={modal} toggle={() => toggle()}>
              <ModalHeader
                className="modal-header-custom"
                toggle={() => toggle()}
              ></ModalHeader>
              <ModalBody>
                <Form>
                  <FormGroup
                    value={selectedCustomer}
                    onChange={(e) => handleSelectedCustomer(e)}
                  >
                    <Label for="exampleSelect">Customer</Label>
                    <Input type="select" name="select" id="exampleSelect">
                      <option value="">Please Select</option>
                      {projects.map((item, index) => (
                        <option key={index} value={item?.customerId}>
                          {item?.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Form>
                {selectedPersons.length > 0 ? (
                  <Form>
                    <FormGroup
                      value={selectProfile}
                      onChange={(e) => handleSelectProfile(e)}
                    >
                      <Label for="personSelect">Person</Label>
                      <Input type="select" name="select" id="personSelect">
                        <option value="">Please Select</option>
                        {selectedPersons?.map((item, index) => (
                          <option value={index}>
                            {item?.fname} {item?.lname}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <Button onClick={() => setProfile()}>Submit</Button>
                  </Form>
                ) : null}
              </ModalBody>
            </Modal>
          </div>
        </DropdownItem>
      ) : null}
      {(props.profile.role === 'Super' || props.profile.role === 'Manager') &&
      !props.options.isCustomerView ? (
        <DropdownItem divider />
      ) : null}
      <DropdownItem
        tag="a"
        href="#"
        onClick={(e) =>
          props.profile.isAdmin
            ? logoutMS().then(props.logoutWithJWT())
            : props.logoutWithJWT()
        }
      >
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  );
};

class NavbarUser extends React.PureComponent {
  state = {
    navbarSearch: false,
    suggestions: [],
  };

  componentDidMount() {
    /*axios.get("/api/main-search/data").then(({ data }) => {
      this.setState({ suggestions: data.searchResult })
    })*/
    getProfile()
      .then((response) => {
        const { fname, lname, email, role, personId, isAdmin } =
          response.data.person;

        if (!email) {
          setJWT(undefined);
          return;
        }
        this.props.setProfile({
          name: `${fname} ${lname}`,
          email,
          role,
          personId,
          isAdmin,
        });
        updateGAUser(() => {
          let nextUserProperties = { personId };
          if (isAdmin) {
            nextUserProperties.customerId = 'admin';
            nextUserProperties.customerName = 'Admin';
          }
          return nextUserProperties;
        });
      })
      .catch((error) => {
        setJWT(undefined);
        console.log('error', error.message);
      });
    getCustomerProfile().then((response) => {
      const data = response.data.customer;
      this.props.setCustomerProfile(data);
      if (data) {
        updateGAUser({
          customerId: data.customerId,
          customerName: data.name,
        });
      }
    });
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch,
    });
  };

  render() {
    const { name } = this.props.profile || {};
    tracker.setUserID(this.props.profile.email);
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600 m-auto">
                {name ? (
                  name
                ) : (
                  <span
                    className="user-name text-bold-600 m-auto"
                    style={{ width: '100px' }}
                  ></span>
                )}
              </span>
            </div>
            <span data-tour="user">
              <img
                src={this.props.userImg}
                className="round"
                height="40"
                width="40"
                alt="avatar"
              />
            </span>
          </DropdownToggle>
          <UserDropdown {...this.props} />
        </UncontrolledDropdown>
      </ul>
    );
  }
}
export default connect(
  (state) => ({ profile: state.profile, options: state.options }),
  {
    logoutWithJWT,
    setProfile,
    setCustomerProfile,
    toggleCustomerView,
  }
)(NavbarUser);
